export { CardAttract } from './CardAttract';
export { type CardAttractProps } from './CardAttract';
